var map = {
	"./a-la-cama.json": 33,
	"./administrathor.json": 34,
	"./amish-paradise.json": 35,
	"./atalanta-golden-odyssey.json": 36,
	"./black-friday-cart-race.json": 37,
	"./bubble-bind.json": 38,
	"./cinco-etapas.json": 39,
	"./contando-hasta-100.json": 40,
	"./conway.json": 41,
	"./duof.json": 42,
	"./elf-hunting.json": 43,
	"./escupitajulus-insanis.json": 44,
	"./fosu.json": 45,
	"./games.json": 15,
	"./greedy-atm.json": 46,
	"./hold-it.json": 47,
	"./identity-thief.json": 48,
	"./info-harvest.json": 49,
	"./jdb.json": 50,
	"./la-kolektanto.json": 51,
	"./one-of-you-is-a-magical-dog.json": 52,
	"./piratinsul.json": 53,
	"./pongmoi.json": 54,
	"./rgb-pong.json": 55,
	"./snakejs.json": 56,
	"./superuatakku.json": 57,
	"./tags.json": 21,
	"./tiny-revolution.json": 58,
	"./tirando-cable.json": 59,
	"./ufo-taxi.json": 60,
	"./zero-gravity-delivery.json": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;